// DEV-401 rollout-version compatibility.
//
// One canonical, non-PII marker is shared by every checkout wire serializer.
// Call sites never supply the marker, so it cannot affect buyerIdentityKey,
// Checkout Session identity, quote/acceptance state, or clientRequestId.

import { CHECKOUT_NEVERBLOCK_ENABLED } from "./neverBlockFlag";

export const CHECKOUT_FLOW_VERSION = "neverblock_deferred_invoice_v1" as const;

export type CheckoutFlowVersion = typeof CHECKOUT_FLOW_VERSION;

/** Return a fresh body and append the exact marker only when the FE flag is on. */
export function appendCheckoutFlowVersion<T extends Record<string, unknown>>(
  body: T,
  enabled: boolean = CHECKOUT_NEVERBLOCK_ENABLED,
): T | (T & { checkoutFlowVersion: CheckoutFlowVersion }) {
  return enabled ? { ...body, checkoutFlowVersion: CHECKOUT_FLOW_VERSION } : { ...body };
}
